import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterTable'
})
export class FilterTablePipe implements PipeTransform {

  transform(items: any[], searchTerm: string): any[] {
    if (!items || !searchTerm) {
      return items;
    }

    searchTerm = searchTerm.toLowerCase();

    return items.filter(item => {
      // Customize this condition based on your data structure
      for (const key in item){
        if(item.hasOwnProperty(key) && item[key] != null && item[key].toString().toLowerCase().includes(searchTerm)){
          return true;
        }
      }
      return false;
    });
  }

}
